module.exports = __webpack_public_path__ + "img/icon_qusetion.453a713e.svg";